module.exports = __webpack_public_path__ + "img/background-crew-tablet.7e8b8396.jpg";